import equipmentsExpandedReducer, {
  equipmentsExpandedAdapter,
  equipmentsExpandedSlice,
} from '@/features/equipments/reducer';

const equipmentsExpandedActions = {
  ...equipmentsExpandedSlice.actions,
};

const equipmentsExpandedSelectors = {
  ...equipmentsExpandedAdapter.getSelectors(),
};

export {
  equipmentsExpandedActions,
  equipmentsExpandedReducer,
  equipmentsExpandedSelectors,
};
